import React from 'react';

import { ToggleSwitch } from '../../../shared/toggle-switch/toggle-switch.component';
import {
  Delivery,
  SendBefore,
} from '../../../../redux/actions/notifications-settings/notification-settings.types';

import * as styles from '../auto-reminders.styles';

export const templateTagExamples = {
  '{first name}': 'Thomas',
  '{last name}': 'Smith',
  '{preferred name}': 'Thom',
  '{date and time}': ' Monday, January 1st at 7:00AM ',
  '{day}': 'Monday',
  '{day of month}': '1st',
  '{month}': 'January',
  '{time}': '7:00 AM',
  '{practice name}': 'devtesting',
  '{practice_name}': 'devtesting',
  '{practice phone}': '123 456 7890',
  '{time early}': '6:45 AM',
  '[{first name}]': 'Thomas, Troyleland, Ty-son, Jimmy, Richard and Robison',
  '[{preferred name}]': 'Thom, Troy, Ty, James, Richy and Robi',
  '[{time}]': '7:00, 7:30, 7:45, 7:50 and 2:00',
  '{wellness form}': `https://book.getweave.com/a1bc2d3e-f456-78gh-ijkl-9mn0o12pqr34/wellness`,
  '{pet name}': 'Barko',
  '[{pet name}]': 'Crookshank and Roofus',
  '{service provider}': 'Dr. Weaver',
  '{service_provider}': 'Dr. Weaver',
};

export const formatNotificationTime = (delivery: Delivery, sendBefore: SendBefore) => {
  let value = Number(sendBefore.value);
  let beforOrAfter = '';
  let deliveryTime = '';
  if (value < 0) {
    value = value * -1;
    beforOrAfter = 'after';
  } else {
    beforOrAfter = 'before';
  }

  if (sendBefore.type !== 'hours') {
    deliveryTime = `${delivery.time}`;
  }
  return `${deliveryTime} ${value} ${sendBefore.type} ${beforOrAfter}`;
};

export const EnabledToggle = ({
  enabled,
  handleToggleSwitch = () => {
    return;
  },
  disabled = false,
}) => (
  <div className={styles.toggle}>
    <ToggleSwitch
      onChange={handleToggleSwitch}
      on={enabled}
      disabled={disabled}
      label={''}
    />
  </div>
);

export const replaceTagsWithExample = (text, templateTagExamples) => {
  const regexMatchPatterns = Object.keys(templateTagExamples)
    .map((tag) => tag.replace(/[.[\]\\]/g, '\\$&'))
    .join('|');
  const re = new RegExp(regexMatchPatterns, 'gi');
  return text.replace(re, (matched) => {
    return templateTagExamples[matched];
  });
};

export const sortByKey = (array, primaryKey, secondaryKey) => {
  return array.sort(function (a, b) {
    const nameComp = ('' + a[primaryKey]).localeCompare(b[primaryKey]);
    const idComp = ('' + a[secondaryKey]).localeCompare(b[secondaryKey]);
    return nameComp || idComp;
  });
};
